const searchParamsToSearchFilters = (searchParams, pageContext, brandId) => {
    const params = {};
    searchParams.forEach((value, key) => {
        let decodedKey = decodeURIComponent(key);
        const decodedValue = decodeURIComponent(value);
        // This key is part of an array
        if (decodedKey.endsWith('[]')) {
            decodedKey = decodedKey.replace('[]', '');
            params[decodedKey] || (params[decodedKey] = []);
            params[decodedKey].push(decodedValue);
            // Just a regular parameter
        }
        else {
            params[decodedKey] = decodedValue;
        }
    });
    const searchRequest = {
        sort: [],
    };
    if (brandId) {
        searchRequest.brandIds = [+brandId];
    }
    else if (pageContext === null || pageContext === void 0 ? void 0 : pageContext.brandId) {
        searchRequest.brandIds = [+(pageContext === null || pageContext === void 0 ? void 0 : pageContext.brandId)];
    }
    if (params.titleInclude) {
        searchRequest.titleInclude = params.titleInclude;
        searchRequest.organicSearchTerm = params.titleInclude[0];
    }
    if (params.campaignTypes) {
        searchRequest.campaignTypes = params.campaignTypes.map((id) => id);
    }
    if (params.retailerIds) {
        searchRequest.retailerIds = params.retailerIds.map((id) => +id);
    }
    if (params.brandIds) {
        searchRequest.brandIds = params.brandIds.map((id) => +id);
    }
    if (params.retailPrice) {
        searchRequest.retailPrice = params.retailPrice.map((id) => {
            if (id === '0to25') {
                return { min: 0, max: 25 };
            }
            if (id === '25to50') {
                return { min: 25, max: 50 };
            }
            if (id === '50to100') {
                return { min: 50, max: 100 };
            }
            if (id === 'over100') {
                return { min: 100 };
            }
            return {};
        });
    }
    if (params.categoryIds) {
        searchRequest.categoryIds = params.categoryIds.map((id) => +id);
    }
    if (params.subCategoryIds) {
        searchRequest.subCategoryIds = params.subCategoryIds.map((id) => +id);
    }
    return searchRequest;
};

export { searchParamsToSearchFilters };
//# sourceMappingURL=searchResultsUtils.js.map
